import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../../components/Navbar";
// import "./styles.css";
import { Space, DatePicker } from "antd";

import { Pie } from "@ant-design/plots";
import { Col, Row, Table } from "antd";
import moment from "moment";
import { Typography } from "antd";
import CountUp from "react-countup";
const { Text } = Typography;

const { RangePicker } = DatePicker;
const formatter = (value) => <CountUp end={value} separator="," />;

const axiosConfig = {
  withCredentials: true,
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
  },
};

function ProductosVendidos() {
  const [from, setFrom] = useState(
    `'${moment().startOf("month").format("YYYY-MM-DD")}'`
  );
  const [to, setTo] = useState(`'${moment().format("YYYY-MM-DD")}'`);
  const [products, setProducts] = useState([]);

  // console.log("Products State:", products);

  const configPie = {
    appendPadding: 20,
    data: products,
    angleField: "Total",
    colorField: "Name",
    radius: 100,
    legend: true,
    label: {
      type: "spider",
      labelHeight: 30,
      content: "{name}\n{percentage}",
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
  };

  const columns = [
    {
      title: "Producto",
      dataIndex: "Name",
      key: "Name",
    },
    {
      title: "Bolsas",
      dataIndex: "Qty",
      key: "Qty",
    },
    {
      title: "Total",
      dataIndex: "Total",
      key: "Total",
      render: (_, products) => {
        return formatter(products.Total);
      },
    },
  ];

  const handleDate = (value) => {
    if (value !== null) {
      setFrom(`'${moment(value[0]._d).format().split("T")[0]}'`);
      setTo(`'${moment(value[1]._d).format().split("T")[0]}'`);
    } else {
      //   props.setData("");
    }
  };

  useEffect(() => {
    axios
      .post(
        "/api/data/productssold",
        { from: from, to: to },
        axiosConfig
      )
      .then((result) => {
        let newArray = result.data.filter((e) => e.Qty >= 1);

        setProducts(newArray);
      })
      .catch((e) => console.log(e));
  }, [from, to]);

  // const Total = () => {
  //   let count = 0;
  //   if (products.Name == "Chipa 1Kg") {
  //     products.forEach((e) => {
  //       count += e.Total;
  //     });
  //   }
  //   console.log("count", count);
  //   return count;
  // };

  return (
    <div className="container">
      <Navbar />
      <div className="datepicker-container">
        <Space direction="vertical" size={15} className="datepicker">
          <Text className="dd">Rango de fechas</Text>
          <RangePicker
            format="DD-MM-YYYY"
            onChange={handleDate}
            defaultValue={[moment().startOf("month"), moment()]}
          />
          <Text className="dd2">
            Desde {moment(from).format("dddd DD")} Hasta{" "}
            {moment(to).format("dddd DD")}
          </Text>
        </Space>
      </div>
      <Row className="pie-container">
        <Col span={20}>
          <Pie {...configPie} autoFit={true} />
        </Col>
      </Row>
      <div className="table-products">
        <Table dataSource={products} columns={columns} rowKey="Name" />
      </div>
    </div>
  );
}

export default ProductosVendidos;
